import { useState } from "react";

/**
 * Custom hook to manage modal states for the Returns component
 */
export function useReturnsModals() {
  // Modal visibility states
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showSourceAuctionsErrorModal, setShowSourceAuctionsErrorModal] = useState(false);
  const [showNoQuantityModal, setShowNoQuantityModal] = useState(false);
  const [showExceedsCapacityModal, setShowExceedsCapacityModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showAccessDeniedModal, setShowAccessDeniedModal] = useState(false);
  
  /**
   * Closes all modals at once
   */
  const closeAllModals = () => {
    setShowSuccessModal(false);
    setShowSourceAuctionsErrorModal(false);
    setShowNoQuantityModal(false);
    setShowExceedsCapacityModal(false);
    setShowConfirmation(false);
    setShowAccessDeniedModal(false);
  };
  
  // Return all state variables and functions
  return {
    showSuccessModal,
    setShowSuccessModal,
    showSourceAuctionsErrorModal,
    setShowSourceAuctionsErrorModal,
    showNoQuantityModal,
    setShowNoQuantityModal,
    showExceedsCapacityModal,
    setShowExceedsCapacityModal,
    showConfirmation,
    setShowConfirmation,
    showAccessDeniedModal,
    setShowAccessDeniedModal,
    closeAllModals
  };
}